import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';
import { customJSText } from '../../../common/docs/content';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import ParentDocCard from '../../common/ParentDocCard';
import { CustomJsCdn } from './CustomJsCdn';
import CustomJSForm from './CustomJSForm';
import VideoBox from '../../../common/custom/VideoBox';
import showAlert from '../../../common/utils/alert';
import ToggleButton from '../../../common/ui/ToggleButton';
import { drapcodeIcon } from '../../../common/custom/icon-library';

export const CustomJs = ({
  projectId,
  version,
  projectDetail,
  actions,
  showCustomJSLoader,
  showCustomJSCDNLoader,
  appSetting,
  toggleFullscreen,
  togglestate,
  deleteFlag,
}) => {
  const { content, loadCustomJsToBuilder } = projectDetail;
  const loadCustomJS = loadCustomJsToBuilder;

  const handleCustomJsSubmit = (values) => {
    actions.addProjectCustomJs({
      projectId,
      version,
      data: values,
    });
  };

  const handleToggleLoadCustomJS = () => {
    const text = loadCustomJS
      ? 'Unload Custom JavaScript from Builder Canvas.'
      : 'Loading Custom JavaScript to Builder Canvas.';
    const preConfirm = () => {
      actions.toggleProjectCustomJs({ projectId, version, data: {} });
    };
    showAlert(
      text,
      preConfirm,
      loadCustomJS ? 'Yes, unload it!' : 'Yes, load it!',
      loadCustomJS ? 'warning' : 'info',
    );
  };

  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <div className="row mx-auto">
          <ParentCardNoCol
            title="Add Custom JS"
            bgColor="drapcode-violet"
            icon="customJS"
            CtaComponent={
              <div className="form-group">
                <button
                  type="button"
                  style={{ background: 'transparent', border: 'none' }}
                  onClick={toggleFullscreen}
                  title="Toggle Fullscreen"
                >
                  <i
                    className={`btn btn-outline-primary btn-xs btn-icon-only ${drapcodeIcon(
                      'fullscreen',
                    )}`}
                    style={{ lineHeight: 1 }}
                  ></i>
                </button>
                &nbsp;
                <ToggleButton
                  name="loadCustomJsToBuilder"
                  title="Load to Builder Canvas (Default: True)"
                  text="Load to Builder Canvas"
                  onChange={handleToggleLoadCustomJS}
                  isChecked={loadCustomJS}
                />
              </div>
            }
          >
            <CustomJSForm
              content={content}
              handleCustomJsSubmit={handleCustomJsSubmit}
              showCustomJSLoader={showCustomJSLoader}
              toggleFullscreen={toggleFullscreen}
              togglestate={togglestate}
            />
          </ParentCardNoCol>
          <CustomJsCdn
            version={version}
            projectId={projectId}
            projectDetail={projectDetail}
            actions={actions}
            showCustomJSCDNLoader={showCustomJSCDNLoader}
            appSetting={appSetting}
            deleteFlag={deleteFlag}
          />
        </div>
      </div>
      <ParentDocCard>
        <h5>
          <b>About Custom JavaScript</b>
        </h5>
        <p>{customJSText}</p>
        <br />
        <DocsLink link="https://academy.drapcode.com/docs/app-settings/custom-javascript/" />
        <br />
        <h4>
          <b>Videos</b>
        </h4>

        <VideoBox
          videoLink="https://www.youtube.com/watch?v=KC1BJ6aHkMM"
          imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/CustomCSSandJs.png"
          heading="Custom JavaScript"
        />
      </ParentDocCard>
    </>
  );
};
